import { render } from "./Bodies.vue?vue&type=template&id=5be546a7&bindings={}"
import script from "./Bodies.vue?vue&type=script&lang=ts"
export * from "./Bodies.vue?vue&type=script&lang=ts"
script.render = render

export default script